<script setup>
import { defineEmits, defineProps, computed, toRefs } from "vue"
import TinymceEditor from "@/components/Base/TinymceEditor3";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get: () => props.modelValue?.data?.value ?? '',
  set: (newValue) => {
    emit('update:modelValue', {
      ...props.modelValue,
      data: {
        ...props.modelValue?.data,
        value: newValue
      }
    });
  }
});
</script>

<template>
  <div>
    <p>Текст для отображения</p>
    <TinymceEditor v-model="value"/>
  </div>
</template>